module.exports = __webpack_public_path__ + "media/media/product-card/software-link-2-aac4191fe11218b2d6d7b8c2ec84fc54.png";